let createInicioFirmaPrendario =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (solicitudId) => {
    let request = buildRequestWithAuth("POST", { Id: solicitudId });

    return fetch(
      `${environment.originacionUrl}/solicitudes/${solicitudId}/docs/firma/inicio`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => response)
      .catch((error) => {
        let resultError = parseError(error, "createInicioFirmaPrendario");
        throw resultError;
      });
  };

let createConsultarEstadoFirmaPrendario =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (solicitudId) => {
    let request = buildRequestWithAuth("GET");

    return fetch(
      `${environment.originacionUrl}/solicitudes/${solicitudId}/firma/estado`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => response.json())
      .catch((error) => {
        let resultError = parseError(error, "createConsultarEstadoFirmaPrendario");
        throw resultError;
      });
  };

let createReenviarInvitacionPrendario =
  ({ fetch, environment, buildRequestWithAuth, errorUnlessOk, parseError }) =>
  (solicitudId, firmantes) => {
    const body = firmantes?.length
      ? { Id: solicitudId, Firmantes: firmantes }
      : { Id: solicitudId };
    let request = buildRequestWithAuth("POST", body);

    return fetch(
      `${environment.originacionUrl}/solicitudes/${solicitudId}/docs/firma/invitacion`,
      request
    )
      .then(errorUnlessOk)
      .then((response) => response)
      .catch((error) => {
        let resultError = parseError(error, "createReenviarInvitacionPrendario");
        throw resultError;
      });
  };

export {
  createInicioFirmaPrendario,
  createConsultarEstadoFirmaPrendario,
  createReenviarInvitacionPrendario,
};
